module.exports = __webpack_public_path__ + "static/media/pl-csharp.81eda716.png";